import clsx from 'clsx';

import Loader from '@/components/ui/Loader';

type Variant = 'primary' | 'secondary';

export interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  labelClassName?: string;
}

export function AppButton({
  variant = 'primary',
  loading = false,
  disabled,
  className,
  children,
  labelClassName,
  type = 'button',
  ...rest
}: AppButtonProps) {
  const base =
    'flex items-center w-fit rounded-lg px-3 py-1 md:px-6 md:py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:bg-second-accent disabled:cursor-not-allowed';

  const stylesByVariant: Record<Variant, string> = {
    primary: 'bg-primary text-text-primary hover:bg-primary-hover focus:ring-primary',
    secondary:
      'bg-transparent border-1 border-solid border-border-secondary hover:bg-grey-secondary focus:ring-gray-300',
  };

  return (
    <button
      type={type}
      className={clsx(base, stylesByVariant[variant], className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      aria-disabled={disabled || loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="h-9 w-9 min-w-9">
          <Loader />
        </span>
      ) : (
        <span className={clsx('--text-button whitespace-nowrap', labelClassName)}>{children}</span>
      )}
    </button>
  );
}

export default AppButton;
